/**
 * 新建角色 
 */
import React from 'react';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { connect } from 'react-redux';
import { Modal, Input, message, Form, Checkbox, Select } from 'antd';
import styles from './AddRole.module.scss';
import model from '@/reducers/permissions/assignauthority/model';


const { TextArea } = Input;
const { Option } = Select;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

class AddRole extends React.Component {
    formRef = React.createRef();
    state = {
        haveId: false,
        title: this.props.title,
        confirmLoading: false,
    }

    componentDidMount() {
        this.props.getListRoleClass();
        const { id, deptId } = this.props.data.role ? this.props.data.role : {};
        this.formRef.current.setFieldsValue({ parentId: id });
        if (id) {
            this.setState({ haveId: true });
            this.props.getListCopyRole({ deptId });
        }
    }

    // 点击确认
    _handleOk = () => {
        this.formRef.current.validateFields().then((fieldsValue) => {
            const { parentId, roleName, remark, copy } = fieldsValue;
            const copyRoleId = copy.check ? (copy.copyRoleId ? copy.copyRoleId : undefined) : undefined;

            http('/?cmd=com.xqxc.api.pig.mis.biz.account.RoleMisService.createRole', { parentId, roleName, remark, copyRoleId }, 'POST').then((response) => {
                message.success('新建成功！');
                this.props.closeMode(true);
            }).catch((e) => {
                message.error(e.message);
            });

        });
    }

    // 点击取消
    _handleCancel = () => {
        this.props.closeMode();
    }

    // 渲染角色下拉列
    _renderOption = (list) => {
        return list.map((item) => {
            return <Option key={item.id} value={item.id}>{item.roleName}</Option>;
        });
    }

    render() {
        const { confirmLoading, title, haveId } = this.state;
        const { listRoleClass, listCopyRole } = this.props;

        return (
            <Modal
                width={900}
                centered
                title={title}
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div>
                    <Form
                        {...formItemLayout}
                        layout="vertical"
                        ref={this.formRef}
                        initialValues={{ copy: { copyRoleId: undefined, check: false } }}
                        scrollToFirstError
                    >
                        <Form.Item
                            label="角色分类"
                            name="parentId"
                            rules={[{ required: true }]}
                        >
                            <Select disabled={haveId} allowClear placeholder='请选择角色分类' onChange={(e, item) => {
                                this.props.getListCopyRole({ deptId: item['data-deptId'] });
                            }}>
                                {
                                    listRoleClass.map((item) => {
                                        return <Option key={item.id} value={item.id} data-deptId={item.deptId}>{item.roleName}</Option>;
                                    })
                                }
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label="角色名称"
                            name="roleName"
                            rules={[
                                { required: true },
                                { max: 20, message: '最多可输入20个字' },
                            ]}>
                            <Input placeholder='请输入角色名称' />
                        </Form.Item>
                        <Form.Item
                            label="角色描述"
                            name="remark"
                            rules={[
                                { max: 200, message: '最多可输入200个字' },
                            ]}>
                            <TextArea rows={4} placeholder="请输入角色描述" />
                        </Form.Item>
                        <Form.Item
                            name='copy'
                            style={{ textAlign: 'right' }}
                        >
                            <Checkbox
                                onChange={(e) => {
                                    let copy = this.formRef.current.getFieldsValue().copy;
                                    this.formRef.current.setFieldsValue({ copy: { ...copy, check: e.target.checked } });
                                }}>复制</Checkbox>
                            <Select
                                allowClear
                                style={{ width: 150, marginRight: 10 }}
                                placeholder='请选择'
                                onChange={(e) => {
                                    let copy = this.formRef.current.getFieldsValue().copy;
                                    this.formRef.current.setFieldsValue({ copy: { ...copy, copyRoleId: e } });
                                }}
                            >
                                {this._renderOption(listCopyRole)}
                            </Select>
                            <span>的角色权限</span>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );
    }
}

AddRole.propTypes = {
    data: PropTypes.object, // 弹框入参
    closeMode: PropTypes.func.isRequired, // 关闭弹框的回调函数
    title: PropTypes.string, // 弹框标题
    getListRoleClass: PropTypes.func, // 获取角色下拉列
    listRoleClass: PropTypes.array, // 角色下拉列
    getListCopyRole: PropTypes.func, // 获取角色下拉列
    listCopyRole: PropTypes.array, // 角色下拉列
};

const mapStateToProps = (state) => ({
    listRoleClass: state.assignauthority.getListRoleClass,
    listCopyRole: state.assignauthority.getListCopyRole,
});

export default connect(mapStateToProps, { ...model.actions })(AddRole);